import { render, staticRenderFns } from "./PCustomerOrderSoloTable.vue?vue&type=template&id=a59c6e66"
import script from "./PCustomerOrderSoloTable.vue?vue&type=script&lang=js"
export * from "./PCustomerOrderSoloTable.vue?vue&type=script&lang=js"
import style0 from "./PCustomerOrderSoloTable.vue?vue&type=style&index=0&id=a59c6e66&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "@/components/PBatchRun/locales.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2FUsers%2Fstv%2FPycharmProjects%2FcomponentDB%2Fvueapp%2Fsrc%2Fcomponents%2FPBatchRun%2FCustomerOrderSolo%2FPCustomerOrderSoloTable.vue&external"
if (typeof block0 === 'function') block0(component)

export default component.exports